<template>
  <v-select
    v-model="statusSelecionados"
    :items="status"
    label="Status Pagamento"
    item-text="text"
    item-value="value"
    multiple
    chips
  />
</template>

<script>
export default {
  name: 'FiltroStatusPagamento',
  data() {
    return {
      status: [
        {
          text: 'Inativo',
          value: -1
        },
        {
          text: 'Regular',
          value: 0
        },
        {
          text: 'Pendente',
          value: 1
        },
        {
          text: 'Inadimplente',
          value: 2
        },
        {
          text: 'Cancelado',
          value: 3
        }
      ],
      statusSelecionados: [0, 1, 2]
    }
  },
  watch: {
    statusSelecionados() {
      this.emitirStatusSelecionados()
    }
  },
  mounted() {
    this.emitirStatusSelecionados()
  },
  methods: {
    emitirStatusSelecionados() {
      this.$emit('filtrar-status-pagamentos', {
        status_pagamento: this.statusSelecionados
      })
    }
  }
}
</script>
